import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TextMaskService } from '@bayclubs/ui-text-mask';
import { camps } from '../../../../../models/models.generated';

@Component({
    selector: 'app-camp-care-slots-edit',
    templateUrl: './camp-care-slots-edit.component.html',
    styleUrls: ['./camp-care-slots-edit.component.scss'],
    standalone: false
})
export class CampCareSlotsEditComponent implements OnInit {

    public form: UntypedFormGroup;

    @Input()
    public slots: camps.TimeRange[];

    constructor(public mask: TextMaskService,
        private formBuilder: UntypedFormBuilder) {
    }

    ngOnInit(): void {
        this.initForm();
    }


    public addSlot(): void {
        if (this.form.invalid) return;

        this.slots.push(<camps.TimeRange>{
            fromMinutes: this.form.value.timeFrom,
            toMinutes: this.form.value.timeTo
        })

        this.initForm()
    }

    private initForm() {
        this.form = this.formBuilder.group({
            timeTo: [720, [Validators.required]],
            timeFrom: [600, [Validators.required]]
        });

        this.form.get('timeFrom').valueChanges
            .subscribe((value: number) => {
                if (value >= this.form.value.timeTo) {
                    this.form.controls.timeTo.setValue(Math.min(value + 15, 1440));
                }
            });

        this.form.get('timeTo').valueChanges
            .subscribe((value: number) => {
                if (value <= this.form.value.timeFrom) {
                    this.form.controls.timeFrom.setValue(Math.max(value - 15, 0));
                }
            });
    }

    public removeSlot(slot: any) {
        var slotIdx = this.slots.indexOf(slot);
        if (slotIdx > -1) {
            this.slots.splice(slotIdx, 1);
        }
    }
}
